import * as Yup from 'yup';

import capsuleValidation from 'src/app/utils/capsuleValidation';

const initialValues = {
  zipcode: '',
};

const ZIP_ERROR_MESSAGE = 'Please enter a valid 5-digit zip code';

const schema = Yup.object().shape({
  zipcode: capsuleValidation.zip(ZIP_ERROR_MESSAGE).required(ZIP_ERROR_MESSAGE),
});

export const validation = {
  initialValues,
  schema,
};
